<template>
    <SupplierCard v-if="supplier" :supplier="supplier"/>
    <BottomNavbar>
        <ul class="navbar-nav ml-md-auto">
            <li class="nav-item py-1">
                <Button size="sm" color="danger" class="mr-2" @click="remove">
                    <i class="icon-trash mr-2"></i>
                    <span>{{ $t('buttons.delete') }}</span>
                </Button>
            </li>
            <li class="nav-item py-1">
                <Button size="sm" color="indigo" @click="edit">
                    <i class="icon-floppy-disk mr-2"></i>
                    <span>{{ $t('buttons.save') }}</span>
                </Button>
            </li>
        </ul>
    </BottomNavbar>
</template>
<script>
import SupplierCard from './cards/SupplierCard.vue';
import BottomNavbar from '../../../../components/new/navbars/FixedBottomNavbar.vue';
import Button from '../../../../components/new/button/AppButton.vue';
import { httpClient } from '../../../../services/HttpClient';
import MessageNotificator from '../../../../services/MessageNotificator.js';
export default {
    name: "EditSupplierPage",
    components: {
        SupplierCard, BottomNavbar, Button
    },
    data() {
        return {
            supplier: null
        }
    },
    methods: {
        async fetchSupplier() {
            await httpClient.get(`/management/suppliers/${this.$route.params.supplierUuid}`).then(response => {
                this.supplier = response.data.data
            })
        },
        async edit() {
            await httpClient.patch(`/management/suppliers/${this.supplier.uuid}`, {
                name: this.supplier.name
            }).then(response => {
                this.supplier = response.data.data
                new MessageNotificator().success(this.$t('alerts.success'))
            })
        },
        remove() {
            new MessageNotificator().confirm(this.$t('alerts.delete_supplier'), async () => {
                await httpClient.delete(`/management/suppliers/${this.supplier.uuid}`).then(() => {
                    this.$router.push({ name: 'IndexSupplierPage' })
                })
            })
        }
    },
    mounted() {
        this.fetchSupplier()
    }
}
</script>
